export default __webpack_public_path__ + "static/media/failed.3ad77da3.svg";